<ion-grid class="background-white">
    <ion-row class="ion-align-items-center ion-justify-content-between page-section">
        <ion-col size="12">
            <div class="title-2">{{ 'welcome' | translate }}</div>
        </ion-col>
        <ion-col size="12">
            <div class="description">{{ 'update_passwords' | translate }}</div>
        </ion-col>
    </ion-row>
    
    <form nz-form [formGroup]="validateForm">
        <ion-row>
            <ion-col size="12">
                <ion-item>
                    <ion-input formControlName="username" [placeholder]="'username' | translate"></ion-input>
                    <ion-icon name="person-outline"></ion-icon>
                    <ion-note slot="error">{{ 'apodo_no_disponible' | translate }}</ion-note>
                </ion-item>
            </ion-col>
            <ion-col size="12">
                <ion-item>
                    <ion-input formControlName="password" [type]="typePassword" [placeholder]="'password' | translate"></ion-input>
                    <ion-icon [name]="isVisiblePassword ? 'eye-off-outline' : 'eye-outline'" slot="end" (click)="togglePassword()" style="margin: 0;"></ion-icon>
                    <ion-note slot="error">{{ 'password_format_incorrect' | translate }}</ion-note>
                </ion-item>
            </ion-col>
            <ion-col size="12">
                <ion-item>
                    <ion-input formControlName="confirmPass" [type]="typeRepeatPassword" [placeholder]="'repeat_password' | translate"></ion-input>
                    <ion-icon [name]="isVisibleRepeatPassword ? 'eye-off-outline' : 'eye-outline'" slot="end" (click)="toggleRepeatPassword()" style="margin: 0;"></ion-icon>
                    <ion-note slot="error">{{ 'contrasena_no_coincide' | translate }}</ion-note>
                </ion-item>
            </ion-col>
            <ion-col size="12">
                <ion-button expand="block" (click)="onSave()" [disabled]="!validateForm.valid">
                    {{ 'guardar' | translate }}
                </ion-button>
            </ion-col>
        </ion-row>
    </form>
</ion-grid>